import getMessagesByKeys from './i18n/getMessagesByKeys';

/**
 * Builds a mapping of available locales for picker options
 *
 * @param {string[]} options - options of 'locales'
 * @param {string} messageLanguage
 */
const adaptLocaleOptionsData = async (options, messageLanguage) => {
    const messageKeys = options.map((localeKey) => `locales.${localeKey}`);
    const localizedLanguages = await getMessagesByKeys(messageKeys, messageLanguage);
    const map = options.reduce(
        (finalMap, languageKey, index) => ({
            ...finalMap,
            [languageKey]: localizedLanguages[index],
        }),
        {},
    );
    return map;
};

export default adaptLocaleOptionsData;
